import { apiSlice } from "app/api/apiSlice";
import { ERP_url } from "../../../urlconfig";

export const CommissionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductList: builder.query({
      query: () => `${ERP_url}/commission/products?start=1&limit=10`,
    }),

    getProductbyId: builder.query({
      query: (product_code) => `${ERP_url}/commission/products/${product_code}`,
    }),
    addproduct: builder.mutation({
      query: (payload) => ({
        url: `${ERP_url}/commission/products/`,
        method: `POST`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    updateProductDatabyId: builder.mutation({
      query: ({ product_code, payload }) => ({
        url: `${ERP_url}/commission/products/${product_code}`,
        method: `PUT`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    addSaathiCommission: builder.mutation({
      query: (payload) => ({
        url: `${ERP_url}/commission/update-commission/`,
        method: `POST`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getAgentsId: builder.query({
      query: (posp_id) => `${ERP_url}/commission/agents?agents=${posp_id}`,
    }),
    getAgentList: builder.query({
      query: ({ searchKey, pagination }) =>
        `/api/v1/onboarding/employees/POSP?q=${searchKey}&per_page=50&page=${pagination.page}`,
    }),
    getAgentDetails: builder.query({
      query: (posp_id) => `${ERP_url}/commission/agents/${posp_id}`,
    }),
    getCommissionDetailsbyid: builder.query({
      query: (posp_id) => `${ERP_url}/commission/commissions/posp/${posp_id}`,
    }),
    createLedgers: builder.mutation({
      query: (payload) => ({
        url: `erp/api/erp/commission/commission-ledger`,
        method: `POST`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getLedgersReport: builder.query({
      query: ({ startDate, endDate, page, per_page, query }) =>
        `${ERP_url}/commission/reports?from_date=${startDate ||
          ""}&to_date=${endDate ||
          ""}&page=${page}&per_page=${per_page}&query=${query}`,
    }),
    getCommissionDashboardData: builder.query({
      query: ({ selectedState, selectedDistrict, selectedProductId }) =>
        `${ERP_url}/commission/dashboard?state=${selectedState}&district=${selectedDistrict}&product=${selectedProductId}`,
    }),
  }),
});

export const {
  useGetProductListQuery,
  useAddproductMutation,
  useGetProductbyIdQuery,
  useUpdateProductDatabyIdMutation,
  useAddSaathiCommissionMutation,
  useGetAgentsIdQuery,
  useGetAgentListQuery,
  useGetAgentDetailsQuery,
  useGetCommissionDetailsbyidQuery,
  useCreateLedgersMutation,
  useGetLedgersReportQuery,
  useGetCommissionDashboardDataQuery,
} = CommissionApiSlice;
